import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from '@mlm/ui/components/toast';
import { apiErrorMessage } from './api';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      successMessage?: string;
      errorMessage?: string;
      /** Error codes the mutation handles itself (no global toast). */
      silentErrorCodes?: string[];
    };
  }
}

/** Every failed mutation toasts the server's message; a success toast is opt-in via `meta`. */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, gcTime: 5 * 60_000, retry: 1 } },
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      const code = (error as { response?: { data?: { error?: string } } })?.response?.data?.error;
      if (code && mutation.meta?.silentErrorCodes?.includes(code)) return;
      toast.error(mutation.meta?.errorMessage ?? apiErrorMessage(error));
    },
    onSuccess: (_data, _vars, _ctx, mutation) => {
      if (mutation.meta?.successMessage) toast.success(mutation.meta.successMessage);
    },
  }),
});
